import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { UtilsService } from './utils.service';
import { ProductOrderByPipe } from '../pipes/product-order-by.pipe';
import { CalcularPipe } from '../pipes/calcular.pipe';
import { PrecioPipe } from '../pipes/precio.pipe';
import { CantidadArticulos, DataOrder, DataResponseOrder, OrderArticulos } from '../../../../../../core/model/DataOrder';
import { DataAddress, DataCFDI, DataRegimenFiscal } from '../../../../../../views/clientes/model/DataAddress';
import { environment, isApp } from '../../../../../../../environments/environment';
import { EmpresaService } from '../../../../../../services/Empresa/Empresa.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { EventService } from '../../../../../../services/event.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { SwalService } from '../../../../../../services/swal/swal.service';
import { ProductData } from '../../../../../../core/model/Product.model';
import { ResumenData } from '../../../../../../core/model/DataCart';
import { DataUser } from '../../../../../../models/generar_pedido/DataUser';

interface BankAccount {
  bank: string;
  accountNumber: string;
  currency: string;
  clabe: string;
}

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  empresaId: string;

  private apiUrl = environment.apiUrl;

  private version_pagina = environment.version;

  /* Se manda a llamar mtEntrega, si es false el envio es por paqueteria si es true es recoger en sucursal*/
  public entrega = new BehaviorSubject<{ mtEntrega?: boolean }>({
    mtEntrega: false,
  });
  /* Se manda a llamar en el componente tipo-compra al seccionar si la compra es a credito o contado */
  public credito = new BehaviorSubject<{
    creditoExcedido?: boolean;
    mensaje: string;
    opcion: string;
  }>({ creditoExcedido: false, mensaje: '', opcion: '' });
  /* Boton de continuar se utiliza solo con stripe, para crear el token del formulario. */
  public boton = new BehaviorSubject<boolean>(false);

  boton$ = this.boton.asObservable();

  /**
   * @TipoDeCompra
   * @value contado|credito
   * botonContadoCredito cuando hacen clic en el radio de tipo de compra
   */
  public botonTipoDeCompra = new BehaviorSubject<string>(null);
  botonTipoDeCompra$ = this.botonTipoDeCompra.asObservable();

  /**
   * @GuardaLaInformacionDelLimiteDeCredito
   *
   */
  public limiteCredito = new BehaviorSubject<{
    creditoExcedido: boolean;
    mensaje: string;
    opcionTipoCompra: string;
  }>({ creditoExcedido: false, mensaje: '', opcionTipoCompra: '' });
  limiteCredito$ = this.limiteCredito.asObservable();

  /**
   * @DatosEnvioDeMercanciaSucursal
   * @value recoger en sucursal | envio a domicilio
   */
  public botonEnvioDeMercanciaSucursal = new BehaviorSubject<{
    direccionSeleccionada: boolean;
    opcionEnvio: string;
    mensaje: string;
    direccionEnvio: any;
  }>({
    direccionSeleccionada: false,
    opcionEnvio: '',
    mensaje: '',
    direccionEnvio: '',
  });
  botonEnvioDeMercanciaSucursal$ =
    this.botonEnvioDeMercanciaSucursal.asObservable();
  /**
   * @DatosEnvioDeMercanciaCedis
   * @value recoger en sucursal | envio a domicilio
   */
  public botonEnvioDeMercanciaCedis = new BehaviorSubject<{
    direccionSeleccionada: boolean;
    opcionEnvio: string;
    mensaje: string;
    direccionEnvio: any;
  }>({
    direccionSeleccionada: false,
    opcionEnvio: '',
    mensaje: '',
    direccionEnvio: '',
  });
  botonEnvioDeMercanciaCedis$ = this.botonEnvioDeMercanciaCedis.asObservable();

  public recalculaResumenCompra = new BehaviorSubject<boolean>(false);
  recalculaResumenCompra$ = this.recalculaResumenCompra.asObservable();

  /**
   * @MedotoDePago
   * @value Pago en caja | paypal | santander |stripe
   */
  public botonMetodoPago = new BehaviorSubject<{
    pagoSeleccionado: boolean;
    opcionPago: string;
    mensaje: string;
  }>({ pagoSeleccionado: false, opcionPago: '', mensaje: '' });
  botonMetodoPago$ = this.botonMetodoPago.asObservable();
  /* false aun no selecciona el metodo de pago, true selecciono un metodo de pago paypal o contado'*/

  /**
   * @Inabiita el formulario de checkout mientras se genera el pedido.
   */
  public formularioCheckout = new BehaviorSubject<boolean>(false);
  formularioCheckout$ = this.formularioCheckout.asObservable();

  public pago = new BehaviorSubject<{
    mtPago?: boolean;
    mensaje: string;
    opcion: string;
  }>({ mtPago: false, mensaje: '', opcion: '' });

  constructor(
    private http: HttpClient,
    private swal: SwalService,
    private login: LoginService,
    private cartService: CartService,
    private eventService: EventService,
    private utilService: UtilsService,
    private orderBy: ProductOrderByPipe,
    private calcularPipe: CalcularPipe,
    private precioPipe: PrecioPipe,
    private datePipe: DatePipe,
    private currency: CurrencyPipe,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  /********************************
   *
   *
   * =======  APKI KABIK  =========
   * ======== HTTP CLIENT =========
   *
   *
   ********************************/

  /* ------------------------------- */
  // Metodo para obtener la direccion del cliente
  // devuelve un objeto de  DATAADDRESS tipo Observable
  public getAddresses = (filtrarCp: boolean = false): Observable<DataAddress[]> => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const dataQuery = {
      client_id: dataUser.client_number,
      empresa_id: this.empresaId,
      esPublicogeneral: dataUser.es_publicogeneral,
      correo: dataUser.email,
      filtrarCp
    };
    return this.http
      .post<any>(
        this.apiUrl + 'account-test/addresses/get_addresses_new_delivery.php',
        dataQuery
      )
      .pipe(
        retry(3),
        catchError(this.handleError),
        map((response) => {
          // console.group('#2 setPrecioPaqueteria ')
          // console.log(response?.PrecioPaqueteria);
          this.cartService.setPrecioPaqueteria(response?.PrecioPaqueteria); // Actualizamos el precio del envio.
          return response.data;
          // console.groupEnd();
        })
      );
  };

  public getUsoCdfi = (): Observable<DataCFDI> => {
    const dataUser: DataUser = this.login.getDataClientePedido();

    const opcion = {
      option: 'GetCFDI',
      client_id: dataUser.client_number,
      empresa_id: this.empresaId,
    };
    return this.http
      .post<DataCFDI>(this.apiUrl + 'account/get_uso_cdfi.php', opcion)
      .pipe(
        retry(3),
        catchError(this.handleError),
        map((response) => {
          return response;
        })
      );
  };

  public getRegimenFiscal = (): Observable<DataRegimenFiscal> => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const opcion = {
      option: 'GetRegimen',
      client_id: dataUser.client_number,
      empresa_id: this.empresaId,
    };
    return this.http
      .post<DataRegimenFiscal>(
        this.apiUrl + 'account/get_regimenFiscal.php',
        opcion
      )
      .pipe(
        retry(3),
        catchError(this.handleError),
        map((response) => {
          return response;
        })
      );
  };

  /*******************************
   *
   * ======== PEDIDOS =========
   *
   ********************************/

  // metodo para que realize el pedido.
  /* solo recibe el tipo de pago (CONTADO O CREDITO) */
  public placeOrder = (
    paymentType: string,
    transaccion?,
    pasarelaPago?: boolean,
    reference?: string,
    operation?: string
  ): Observable<DataResponseOrder> => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const dataOrder: OrderArticulos = this.itemsOrder();
    const resumenDeCompra: ResumenData = this.getResumen();
    const tipoEntrega = this.tipoEntrega();
    const tipoEntregaCedis = this.tipoEntregaCedis();

    let hasSucursal: number = 0;
    let hasCedis: number = 0;
    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      if (itemProduct.isCedis) {
        hasCedis++;
      } else {
        hasSucursal++;
      }
    });

    const dataQuery = {
      p: environment.production,
      order: dataOrder.Order,
      empresa: this.empresaId,
      direccion: this.getAddress(),
      direccionCedis: this.getAddressCedis(),
      client_info: [dataUser],
      tipo_compra: paymentType,
      resumenDeCompra,
      tipoEntrega,
      tipoEntregaCedis,
      pasarelaPago: pasarelaPago ?? false,
      transaccion: transaccion ?? null,
      cfdi: this.getCFDI(),
      version_pagina: (isApp ? 'App_' : 'Web_') + this.version_pagina,
      cantidadDeArticulos: dataOrder.CantidadArticulos,
      ipify: btoa(localStorage.getItem('ipify')),
      mail: hasSucursal > 0 ? this.getMail() : null,
      mailCedis: hasCedis > 0 ? this.getMailCEDISOnlyClient() : null,
      mailComplete: hasCedis > 0 ? this.getMailCEDIS() : null,
      isTesting: false,
      reference: reference ?? '',
      operation: operation ?? ''
    };
    console.log("datos query", dataQuery)
    return this.http
      .post<DataResponseOrder>(
        this.apiUrl + 'Servicios-web/Order/Order_new_delivery_test.php', // ************* Al subir a produccion cambiarlo al Order.php **********
        dataQuery
      )
      .pipe(
        catchError(this.handleError),
        map((response) => {
          return response;
        })
      );
  };

  // metodo para guardar el pedido en la tabla auxiliar de pedidos
  // se guarda para tener referencia de pedido y un respaldo de quien lo hizo
  /* recibe como parametro el NUMERO DE PEDIDO */
  public addPedidoWeb = (numberPedido: number) => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const data = {
      client_id: dataUser.client_number,
      pedido_id: numberPedido,
      email: dataUser.email,
      empresa_id: this.empresaId,
    };
    return this.http.post(this.apiUrl + 'pedidos_web/pedidos.php', data).pipe(
      retry(3),
      catchError(this.handleError),
      map((response) => response)
    );
  };

  // metodo que valida la paridad.
  // esto es por si el tipo de cambio no se a cambiado en el ERP
  // se tiene que ejecutar antes de que se haga un pedido
  public validarParidad = (): any => {
    return this.http
      .post<any>(this.apiUrl + 'pedidos_web/validarParidad.php', {
        idEmpresa: 1,
      })
      .pipe(
        catchError(this.handleError),
        map((response) => {
          if (response.status) {
            return response;
          } else {
            return of(null);
          }
        })
      );
  };

  /* public setEncrypt = (xml: any) => {

    return this.http.post(environment.encrypt, { cadena: xml }).pipe(
      retry(3),
      catchError(this.handleError),
      map((response) => response)
    );
  };

  public getGeneratePayment = (xml: any) => {

    return this.http.post(environment.generate, { pgs: xml }).pipe(
      retry(3),
      catchError(this.handleError),
      map((response) => response)
    );
  }

  public getDecrypt(cadena: string): Observable<any> {
    return this.http.post(environment.decrypt, { cadena }).pipe(
      retry(3),
      catchError(this.handleError),
      map(response => {
        return response;
      })
    );
  } */

  /********************************
   *
   *
   * ========== METODOS  ==========
   *
   *
   ********************************/
  // este metodo es para construir los item que se le mandaran al web services y para imprimir en el correo
  // los datos se sacan del **** LOCALSTORAGE ****
  // devuelve un objeto de ** DataOrder **
  public itemsOrder = (): OrderArticulos => {
    const itemOrder: DataOrder[] = [];
    let itemsData: ProductData[] = JSON.parse(
      localStorage.getItem('items-cart-login')
    );
    itemsData = this.orderBy.transform(itemsData, 'Checkout_Service_order'); // odernamos el array primero cedis despues sucursal
    // console.log('order by:', itemsData);
    let CantidadDeArticulosCedis = 0;
    let CantidadDeArticulosSucursal = 0;
    itemsData.forEach((itemProduct: ProductData) => {
      if (itemProduct.isCedis) {
        CantidadDeArticulosCedis++;
      } else {
        CantidadDeArticulosSucursal++;
      }
      const itemAux: DataOrder = {
        sku: itemProduct.ClaveArticulo,
        claveArticuloProveedor: itemProduct.ClaveArticuloProveedor,
        claveArticulo: itemProduct.ClaveArticulo,
        quantity: itemProduct.CANT_CAR,
        almacen: String(itemProduct.AlmacenID).trim(),
        precio: itemProduct.PagarConKabikCoin ? 0 : this.getPrice(itemProduct.PrecioNormal, itemProduct.PrecioVenta),
        porcentajeIva: itemProduct.IVA,
        descripcion: itemProduct.Descripcion,
        pagarConKbCoin: itemProduct.PagarConKabikCoin,
        puntosKBCoin: itemProduct.PuntosKBCoin,
        isCedis: itemProduct.isCedis,
        existenciasCedis: itemProduct.ExistenciasCedis,
        existenciasSucursal: itemProduct.ExistenciasSucursal,
        Cedi: itemProduct.Cedis,
      };
      itemOrder.push(itemAux);
    });
    const cantidadArticulos: CantidadArticulos = {
      CantidadDeArticulosSucursal,
      CantidadDeArticulosCedis,
    };
    const orderArticulos: OrderArticulos = {
      Order: itemOrder,
      CantidadArticulos: cantidadArticulos,
    };

    this.eventService.send("updCart", orderArticulos);
    return orderArticulos;
  };

  private tipoEntrega = (): string => {
    // const address = JSON.parse(localStorage.getItem('address-envio'));
    const tipoEntrega = localStorage.getItem('tipo-entrega-sucursal');
    return tipoEntrega; // ? 'envio' : null;
  };

  private tipoEntregaCedis = (): string => {
    // const address = JSON.parse(localStorage.getItem('address-envio-cedis'));
    // return address ? 'envio' : null;
    const tipoEntrega = localStorage.getItem('tipo-entrega-cedis');
    return tipoEntrega;
  };

  // Metodo para obtener el precio dependiendo si tiene descuento
  /* Recobe solo el PrecioVenta y PrecioNormal */
  private getPrice = (precioNormal: number, precioVenta: number): number => {
    return Number(precioNormal) >= Number(precioVenta)
      ? precioVenta
      : precioNormal;
  };

  // obtenemos la direccion del LOCALSTORAGE
  /* devuelve un objeto -- si en dado caso no selecciono o no hay direccion se devuelve nulo */
  private getAddress = () => {
    if (localStorage.getItem('tipo-entrega-sucursal') === 'envio' || localStorage.getItem('tipo-entrega-sucursal') === 'envioDomicilio') {
      const address = JSON.parse(localStorage.getItem('address-envio'));
      return address ? address : null;
    }
    return null;
  };

  private getAddressCedis = () => {
    // const address = JSON.parse(localStorage.getItem('address-envio-cedis'));
    // return address ? address : null;
    if (localStorage.getItem('tipo-entrega-cedis') === 'envio') {
      const address = JSON.parse(localStorage.getItem('address-envio-cedis'));
      return address ? address : null;
    }
    return null;
  };

  private getResumen = (): ResumenData => {
    return JSON.parse(localStorage.getItem('resumen-cart-login'));
  };

  private getCFDI = (): string => {
    return localStorage.getItem('cliente-CFDI'); //JSON.parse(localStorage.getItem('cliente-CFDI'));
  };

  public getTipoDeCompra$ = () => {
    return this.botonTipoDeCompra$;
  };

  public addTipoDeCompra$ = (newValue: string) => {
    this.botonTipoDeCompra.next(newValue);
  };

  public completeTipoDeCompra$ = () => {
    this.botonMetodoPago.next(null);
    this.botonTipoDeCompra.complete();
  };

  public getEnvioMercanciaSucursal$ = () => {
    return this.botonEnvioDeMercanciaSucursal$;
  };

  public addEnvioMercanciaSucursal$ = (
    direccionSeleccionada: boolean,
    opcionEnvio: string,
    mensaje: string,
    direccionEnvio
  ) => {
    this.botonEnvioDeMercanciaSucursal.next({
      direccionSeleccionada,
      opcionEnvio,
      mensaje,
      direccionEnvio,
    });
  };
  public completeMercanciaSucursal$ = () => {
    this.botonEnvioDeMercanciaSucursal.next(null);
    this.botonEnvioDeMercanciaSucursal.complete();
  };

  public getEnvioMercanciaCedis$ = () => {
    return this.botonEnvioDeMercanciaCedis$;
  };

  public addEnvioMercanciaCedis$ = (
    direccionSeleccionada: boolean,
    opcionEnvio: string,
    mensaje: string,
    direccionEnvio
  ) => {
    this.botonEnvioDeMercanciaCedis.next({
      direccionSeleccionada,
      opcionEnvio,
      mensaje,
      direccionEnvio,
    });
  };

  public completeEnvioMercanciaCedis$ = () => {
    this.botonEnvioDeMercanciaCedis.next(null);
    this.botonEnvioDeMercanciaCedis.complete();
  };

  public getLimiteDeCredito$ = () => {
    return this.limiteCredito$;
  };

  public addLimiteDeCredito$ = (
    creditoExcedido: boolean,
    mensaje: string,
    opcionTipoCompra: string
  ) => {
    this.limiteCredito.next({ creditoExcedido, mensaje, opcionTipoCompra });
  };

  public completeLimiteCredito$ = () => {
    this.limiteCredito.next(null);
    this.limiteCredito.complete();
  };

  public getMetodoPago$ = () => {
    return this.botonMetodoPago$;
  };

  public addMetodoPago$ = (
    pagoSeleccionado: boolean,
    opcionPago: string,
    mensaje: string
  ) => {
    this.botonMetodoPago.next({ pagoSeleccionado, opcionPago, mensaje });
  };

  public completeMetodoPago$ = () => {
    this.botonMetodoPago.next(null);
    this.botonMetodoPago.complete();
  };

  public addRecalculaResumen$ = (newValue: boolean) => {
    this.recalculaResumenCompra.next(newValue);
  };

  public getRecalculaResumen$ = () => {
    return this.recalculaResumenCompra$;
  };

  public completeRecalculaResumen$ = () => {
    this.recalculaResumenCompra.next(null);
    this.recalculaResumenCompra.complete();
  };

  public addformularioCheckout$ = (newValue: boolean) => {
    this.formularioCheckout.next(newValue);
  };

  public getformularioCheckout$ = () => {
    return this.formularioCheckout$;
  };

  public completeformularioCheckout$ = () => {
    this.formularioCheckout.next(null);
    this.formularioCheckout.complete();
  };

  private handleError = (error: HttpErrorResponse | any) => {
    const cliente = this.login.getDataClientePedido();
    this.addformularioCheckout$(false);
    this.swal.swalError(
      'Generar pedido',
      'Lo sentimos, ocurrio un error de comunicación.<br/><br/>Error: ' +
      error.message +
      '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
      cliente.client_number +
      '<br/>Nombre: ' +
      cliente.company_name +
      '<br/>Correo electrónico: ' +
      cliente.email +
      '<br/>Almacén: ' +
      cliente.almacenPre +
      '</p></div>'
    );
    return throwError(error);
  };

  getMail() {
    let dataPage: any = {};
    dataPage.today = new Date();
    dataPage.user = this.login.getDataClientePedido();
    dataPage.nombreVendedor = this.login.getNombreVendedor();
    dataPage.cartResumen = this.cartService.calcularResumen(null);

    let htmlSend: string = `
  <html>

<head>
</head>

<body>
  <section style="max-width: 1000px; margin: auto;" id="allMail">
    <div>
      `;

    if (this.getFromLocalStg('resumen-cart-login')?.totalKbCoins > 0) {
      htmlSend += `<p class="title-kabikCoin">
      <p style="text-align: center; font-weight: bold;">&#10024; Lo haz hecho muy bien!! haz utilizado
        <strong>${this.getFromLocalStg('resumen-cart-login')?.totalKbCoins}</strong> ${this.empresaId == '1' ? 'KabiCoins' : 'Puntos azules'} &#10024;
      </p>
      </>`;
    }

    htmlSend += `
    </div>


    <div style="display: block; max-width: 1350px; margin: auto;">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
        <div style="padding:20px 20px 5px 20px; display:inline-block; vertical-align:top; font-size: 3rem; font-weight: bold;">`;
          if (this.empresaId == '1') {
            htmlSend += `<span>KAB</span><span style="color: #39a5dd">IK</span>`;
          } else {
            htmlSend += `<span style="color: #29285b; font-style: italic">LE<span style="color: #179bd7">TECH</span></span>`;
          }
          htmlSend += `
        </div>

        <div style="display: inline-block;
        vertical-align: top;text-align: end;
        padding: 20px 20px 5px 20px;">
          <div style="display: grid; grid-template-columns: auto auto; gap: 15px; justify-content: flex-end;">
            <span>
              <p style="margin: 0;font-size: 18px;;">Pedido</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900; color: #00a61a;">
                [-REPLACE-PEDIDO-SUCURSAL-]
              </p>
            </span>
            <span>
              <p style="margin: 0;font-size: 18px;">Total</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900;">
                $[-REPLACE-PEDIDO-SUCURSAL-TOTAL-]
              </p>
            </span>
          </div>
        </div>
      </div>

      <div style="height: 2px;
      width: 100%;
      background-color: #66a2d9;"></div>
    </div>


    <div style="max-width: 1350px;
    margin: auto;
    align-items: end;
    border-bottom: 1px solid #cacaca;">
      <div style="text-align: start; padding: 5px 20px 5px 20px;vertical-align:middle; width:50%;display: inline-block;">
        <div>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            ${dataPage.user.client_number} ${dataPage.user.company_name}
          </p>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            Correo cliente:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.email
      }</strong>
          </p>

          <p style=" margin: 0;
            font-size: 16px;
            margin-bottom: 5px;">
            Teléfono:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.telefono ?? '-'
      }</strong>
          </p>
        </div>

        <p style="margin: 0;
        font-size: 16px;
        margin-bottom: 5px;">
          Vendedor: <span>${dataPage.user.vendedorNombre}</span>
        </p>

        <p style="margin: 0;
        font-size: 16px;">
          Generado por: <span>${dataPage.user.vendedorLevantaPedido ? dataPage.nombreVendedor : dataPage.user.nombre}</span>
        </p>

      </div>

      <div style="text-align: end;
      padding: 5px 20px 5px 20px;vertical-align:middle;width: calc(50% - 90px);
      display: inline-block;">
      <p style="font-size: 16px; margin: 0; margin-bottom: 5px;">
        ${this.datePipe.transform(dataPage.today, "dd/MM/yyyy HH:mm:ss")}
      </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Tipo de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("tipo-pago")}</span>
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("pasarela-pago")}</span>
        </p>
        <p style="font-size: 16px; margin: 0; margin-bottom: 5px;">
          ${this.getFromLocalStg('cliente-CFDI')} -
          ${this.getCFDIData(this.getFromLocalStg('cliente-CFDI'))?.description}
        </p>

        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de entrega:
          <strong style="text-transform: uppercase; color: #06a81f;">
            ${this.getFromLocalStg("tipo-entrega-sucursal") == "sucursal"
        ? "Recoger en sucursal"
        : (this.getFromLocalStg("tipo-entrega-sucursal") == "envio" ? "Enviar por paquetería" : "Enviar a domicilio")
      }
          </strong>
        </p>

        `;


    htmlSend += `
      </div>`
    if (this.getFromLocalStg('address-envio') && (this.getFromLocalStg('tipo-entrega-sucursal') == 'envio' ||
      this.getFromLocalStg('tipo-entrega-sucursal') == 'envioDomicilio')) {
      htmlSend += `
        <div style="border: 1px solid #ddd;
        padding: 5px 10px;
        text-align: initial;
        border-radius: 8px;
        background-color: #f2f2f2;
        width: calc(100% - 70px);
        margin: 5px 20px">
          <p style="color:#06a81f; font-size:16px;margin: 0;
          margin-bottom: 0px;">
            Dirección de envío
          </p>
          <div style="display: grid; grid-template-columns: auto auto;">
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Nombre:</strong> ${this.getFromLocalStg("address-envio").nombre}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Dirección:</strong> 
              ${this.getFromLocalStg("address-envio").calle} 
              ${this.getFromLocalStg("address-envio").numExterior}
              ${this.getFromLocalStg("address-envio").numInterior == '' ? '' : '-' + this.getFromLocalStg("address-envio").numInterior}, 
              Col. ${this.getFromLocalStg("address-envio").colonia} ${this.getFromLocalStg("address-envio").codigoPostal},
              ${this.getFromLocalStg("address-envio").ciudad}, ${this.getFromLocalStg("address-envio").estado}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Referencia:</strong> ${this.getFromLocalStg("address-envio").referencia}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Teléfono:</strong> ${this.getFromLocalStg("address-envio").telefono}
            </p>
          </div>
        </div>`;
    }
    htmlSend += `
    </div>



    </div>


    <div style="max-width: 1350px;
    margin: auto;
    border-top: 1px solid #cacaca;
    border-bottom: 1px solid #cacaca;">

      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(12%);">Almacén</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(16%);">Clave</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(40%);">Descripción</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(8% - 10px);">Cantidad</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(10%);">Precio</p>
      <p style="text-align: end;
      margin: 3px 0;
      font-size: 14px;
      padding-right: 0px;
      font-weight: 900;
      display: inline-block;
      width: calc(10% - 10px);">Importe</p>
    </div>


    `;

    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      if (!itemProduct.isCedis) {
        htmlSend += `<div style="max-width: 1350px;
        margin: auto;
        border-top: 1px solid #cacaca;
        border-bottom: 1px solid #cacaca;">

      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(12%);color: #00a61a; text-transform: uppercase;">
        ${itemProduct.isCedis ? "CDMX" : this.empresaId == '1' ? "Tampico" : this.login.getDataClientePedido().sucursal}
      </p>

      <div style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(16%);">

        <p style="margin:0;"><span style="color: #00a61a">${itemProduct.ClaveArticuloProveedor}</span></p>

      </div>
      <p style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(40%);">${itemProduct.Descripcion}</p>
      <p style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(8% - 10px);">${itemProduct.CANT_CAR}</p>


      <p style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(10%);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, 1,
            (itemProduct.PagarConKabikCoin === undefined
              ? false
              : itemProduct.PagarConKabikCoin)), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, 1,
            (itemProduct.PagarConKabikCoin === undefined
              ? false
              : itemProduct.PagarConKabikCoin)), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `
      <p style="text-align: end;
      margin: 5px 0;
      font-size: 14px;
      padding-right: 0px;
      vertical-align: top;
      display: inline-block;
      width: calc(10% - 10px);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta,
            itemProduct.CANT_CAR, (itemProduct.PagarConKabikCoin === undefined
              ? false
              : itemProduct.PagarConKabikCoin)), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta,
            itemProduct.CANT_CAR, (itemProduct.PagarConKabikCoin === undefined
              ? false
              : itemProduct.PagarConKabikCoin)), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `</p>`;

        htmlSend += `
    </div>`;
      }
    });

    htmlSend += `

    <div style="max-width: 1350px;
      margin: auto;
      align-items: end;">
      <div></div>

      <div style="text-align: end;
      padding: 10px 20px;">

        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 5px;
        justify-content: end;
        text-align:end">
          Envio:
          <strong>$ ${this.getFromLocalStg('resumen-cart-login')?.envio}</strong>
        </p>

        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          SubTotal:
          <strong>$ [-REPLACE-PEDIDO-SUCURSAL-SUBTOTAL-]</strong>
        </p>
        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          IVA (16%):
          <strong>$ [-REPLACE-PEDIDO-SUCURSAL-IVA-]</strong>
        </p>

        <div style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          <div style="height: 2px;
        width: 100%;
        background-color: #66a2d9;"></div>
        </div>

        <p style="text-align: end;margin: 0;
        font-size: 16px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 0px;
        justify-content: end;
        text-align:end">
          <strong>Total: $ [-REPLACE-PEDIDO-SUCURSAL-TOTAL-]</strong>
        </p>
      </div>
    </div>

    <div style="display:grid;max-width:700px;margin:auto;border: 1px solid #eaeaea;
    padding: 10px;
    border-radius: 8px;">
      ${this.generateBankAccountsTable(this.empresaId)}
    </div>

    <div style="display: grid;
    max-width: 1350px;
    margin: auto;
    align-items: end;
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #e7e6e6;
    border-radius: 8px;
    gap: 5px;">
      <div style="font-size: 14px">
        <strong>Importante: </strong>El tipo de cambio es ilustrativo, el monto en pesos totalizado no es
        definitivo. Se calculará el monto total utilizando el tipo de cambio
        comercial vigente en la fecha de emisión de la factura correspondiente.
      </div>
      <div style="font-size: 14px">
        <strong>Importante: </strong>Si este pedido no se factura dentro de 48 horas se cancelará de manera automática.
        El tiempo de entrega estimado para articulos del almacén CDMX son 3 a 5 días hábiles.
      </div>

      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Estimado cliente: en caso de no conocer la operación y/o desea reportar un pago repórtelo a la brevedad al
          correo cxc@${this.empresaId == '1' ? 'kabik.com.mx' : 'letech.mx'}
        </p>
      </div>
      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Lunes a Viernes 9:00am - 6:00pm y Sábado 9:00am - 1:00pm
        </p>
      </div>

      <div
        style="display:grid;grid-template-columns:auto auto auto; justify-content:center; gap: 15px; text-align: center; font-size: 14px">
        <a href="https://www.facebook.com/${this.empresaId == '1' ? 'kabikmx' : 'letechmx'}" style="text-decoration: none; color: #207fd3">
          Facebook
        </a>
        <a href="https://${this.empresaId == '1' ? 'kabik' : 'letech'}.mx/" style="text-decoration: none; color: #207fd3">
          ${this.empresaId == '1' ? 'Kabik' : 'Letech'}
        </a>
        <a href="mailto:ventas@${this.empresaId == '1' ? 'kabik.com' : 'letech'}.mx" style="text-decoration: none; color: #207fd3">
          Contactanos
        </a>
      </div>
    </div>
  </section>
</body>

</html>

  `;
    return htmlSend;
  }

  getMailCEDISOnlyClient() {
    let dataPage: any = {};
    dataPage.today = new Date();
    dataPage.user = this.login.getDataClientePedido();
    dataPage.nombreVendedor = this.login.getNombreVendedor();
    dataPage.cartResumen = this.cartService.calcularResumen(null);

    let htmlSend: string = `
    <html>

<head>
</head>

<body>
  <section style="max-width: 1000px; margin: auto;" id="allMail">
    <div style="">
      `;

    if (this.getFromLocalStg('resumen-cart-login')?.totalKbCoins > 0) {
      htmlSend += `<p class="title-kabikCoin">
      <p style="text-align: center; font-weight: bold;">&#10024; Lo haz hecho muy bien!! haz utilizado
        <strong>${this.getFromLocalStg('resumen-cart-login')?.totalKbCoins}</strong> ${this.empresaId == '1' ? 'KabiCoins' : 'Puntos azules'} &#10024;
      </p>
      </>`;
    }

    htmlSend += `

    </div>


    <div style="display: block; max-width: 1350px; margin: auto;">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
        <div style="padding:20px 20px 5px 20px; display:inline-block; vertical-align:top; font-size: 3rem; font-weight: bold;">`;
          if (this.empresaId == '1') {
            htmlSend += `<span>KAB</span><span style="color: #39a5dd">IK</span>`;
          } else {
            htmlSend += `<span style="color: #29285b; font-style: italic">LE<span style="color: #179bd7">TECH</span></span>`;
          }
          htmlSend += `
        </div>

        <div style="display: inline-block;
        vertical-align: top;text-align: end;
        padding: 20px 20px 5px 20px;">
          <div style="display: grid; grid-template-columns: auto auto; gap: 15px; justify-content: flex-end;">
            <span>
              <p style="margin: 0;font-size: 18px;;">Pedido</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900; color: #00a61a;">
                [-REPLACE-PEDIDO-CEDIS-]
              </p>
            </span>
            <span>
              <p style="margin: 0;font-size: 18px;">Total</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900;">
                $[-REPLACE-PEDIDO-CEDIS-TOTAL-]
              </p>
            </span>
          </div>
        </div>
      </div>

    <div style="height: 2px;
      width: 100%;
      background-color: #66a2d9;"></div>
    </div>


    <div style="max-width: 1350px;
    margin: auto;
    align-items: end;
    border-bottom: 1px solid #cacaca;">
      <div style="text-align: start;
      padding: 5px 20px; vertical-align:middle; width:50%;display: inline-block;">
        <div>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            ${dataPage.user.client_number} ${dataPage.user.company_name}
          </p>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            Correo cliente:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.email
      }</strong>
          </p>

          <p style=" margin: 0;
            font-size: 16px;
            margin-bottom: 5px;">
            Teléfono:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.telefono ?? '-'
      }</strong>
          </p>
        </div>

        <p style="margin: 0;
        font-size: 16px;
        margin-bottom: 5px;">
          Vendedor: <span>${dataPage.user.vendedorNombre}</span>
        </p>

        <p style="margin: 0;
        font-size: 16px;
        margin-bottom: 0;">
          Generado por: <span>${dataPage.user.vendedorLevantaPedido ? dataPage.nombreVendedor : dataPage.user.nombre}</span>
        </p>

      </div>

      <div style="text-align: end;
      padding: 5px 20px;vertical-align:middle;width: calc(50% - 90px);
      display: inline-block;">
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          ${this.datePipe.transform(dataPage.today, "dd/MM/yyyy HH:mm:ss")}
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Tipo de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("tipo-pago")}</span>
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("pasarela-pago")}</span>
        </p>
        <p style="font-size: 16px; margin: 0; margin-bottom: 5px;">
          ${this.getFromLocalStg('cliente-CFDI')} -
          ${this.getCFDIData(this.getFromLocalStg('cliente-CFDI'))?.description}
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de entrega:
          <strong style="text-transform: uppercase; color: #06a81f;">
          ${this.getFromLocalStg("tipo-entrega-cedis") == 'sucursal' ? 'Recoger en sucursal' : 'Enviar por paquetería'}</strong>
        </p>
        `;

    htmlSend += `
      </div>`
    if (this.getFromLocalStg("address-envio-cedis") && this.getFromLocalStg("tipo-entrega-cedis") == "envio") {
      htmlSend += `
        <div style="border: 1px solid #ddd;
        padding: 5px 10px;
        text-align: initial;
        border-radius: 8px;
        background-color: #f2f2f2;
        width: calc(100% - 70px);
        margin: 5px 20px">
          <p style="color:#06a81f; font-size:16px;margin: 0;
          margin-bottom: 0px;">
            Dirección de envío
          </p>

          <div style="display: grid; grid-template-columns: auto auto;">
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Nombre:</strong> ${this.getFromLocalStg("address-envio-cedis").nombre}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Dirección:</strong> 
              ${this.getFromLocalStg("address-envio-cedis").calle}
              ${this.getFromLocalStg("address-envio-cedis").numExterior}
              ${this.getFromLocalStg("address-envio-cedis").numInterior == '' ? '' : '-' + this.getFromLocalStg("address-envio-cedis").numInterior}, 
              Col. ${this.getFromLocalStg("address-envio-cedis").colonia}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Referencia:</strong> ${this.getFromLocalStg("address-envio-cedis").referencia}
            </p>
            <p style="margin:0;font-size:14px;margin-bottom:2px;">
              <strong style="">Teléfono:</strong> ${this.getFromLocalStg("address-envio-cedis").telefono}
            </p>
          </div>
        </div>`;
    }

    htmlSend += `
        
    </div>
      
    </div>



    </div>


    <div style="max-width: 1350px;
      margin: auto;
      border-top: 1px solid #cacaca;
      border-bottom: 1px solid #cacaca;">



      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(12%);">Almacén</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(16%);">Clave</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(40%);">Descripción</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(8% - 10px);">Cantidad</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(10%);">Precio</p>
      <p style="text-align: end;
      margin: 3px 0;
      font-size: 14px;
      padding-right: 0px;
      font-weight: 900;
      display: inline-block;
      width: calc(10% - 10px);">Importe</p>
    </div>


    `;

    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      if (itemProduct.isCedis) {
        htmlSend += `<div style="max-width: 1350px;
        margin: auto;
        border-top: 1px solid #cacaca;
        border-bottom: 1px solid #cacaca;">

      <p
        style="text-align: center;
        margin: 5px 0;vertical-align: top;
        font-size: 14px;
        font-weight: 900;display:inline-block; width:calc(12%);color: #00a61a; text-transform: uppercase; font-weight: 900">
        ${itemProduct.isCedis ? "CDMX" : this.empresaId == '1' ? "Tampico" : this.login.getDataClientePedido().sucursal}
      </p>

      <div style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(16%);">

        <p style="margin:0;font-weight: 900"><span style="color: #00a61a">
          ${itemProduct.ClaveArticuloProveedor}
        </span></p>
        
      </div>

      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(40%);">${itemProduct.Descripcion}</p>

        <p style="text-align: center;
          margin: 5px 0;
          font-size: 14px;vertical-align: top;
          display:inline-block; width:calc(8% - 10px);">
          ${itemProduct.CANT_CAR}
        </p>


        <p style="text-align: center;
          margin: 5px 0;
          font-size: 14px;vertical-align: top;
          display:inline-block; width:calc(10%);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, 1,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, 1,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `
      <p style="text-align: end;
      margin: 5px 0;
      font-size: 14px;
      padding-right: 0px;
      font-weight: 900;vertical-align: top;
      display: inline-block;
      width: calc(10% + 10px);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, itemProduct.CANT_CAR,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, itemProduct.CANT_CAR,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `</p>`;

        htmlSend += `
    </div>`;
      }
    });

    htmlSend += `

    <div style="max-width: 1350px;
      margin: auto;
      align-items: end;">
      <div></div>

      <div style="text-align: end;
      padding: 10px 20px;">

        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          Envio:
          <strong>$ ${this.precioPipe.transform(this.getFromLocalStg('resumen-cart-login')?.envio)}</strong>
        </p>

        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          SubTotal:
          <strong>$ [-REPLACE-PEDIDO-CEDIS-SUBTOTAL-]</strong>
        </p>
        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          IVA (16%):
          <strong>$ [-REPLACE-PEDIDO-CEDIS-IVA-]</strong>
        </p>

        <div style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          <div style="height: 2px;
        width: 100%;
        background-color: #66a2d9;"></div>
        </div>

        <p style="text-align: end;margin: 0;
        font-size: 16px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          <strong>Total: $ [-REPLACE-PEDIDO-CEDIS-TOTAL-]</strong>
        </p>
      </div>
    </div>

    <div style="display:grid;max-width:700px;margin:auto;border: 1px solid #eaeaea;
      padding: 10px;
      border-radius: 8px;">

      ${this.generateBankAccountsTable(this.empresaId)}
    </div>

    <div style="display: grid;
    max-width: 1350px;
    margin: auto;
    align-items: end;
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #e7e6e6;
    border-radius: 8px;
    gap: 5px;">
      <div style="font-size: 14px">
        <strong>Importante: </strong>El tipo de cambio es ilustrativo, el monto en pesos totalizado no es
        definitivo. Se calculará el monto total utilizando el tipo de cambio
        comercial vigente en la fecha de emisión de la factura correspondiente.
      </div>
      <div style="font-size: 14px">
        <strong>Importante: </strong>Si este pedido no se factura dentro de 48 horas se cancelará de manera automática.
        El tiempo de entrega estimado para articulos del almacén CDMX son 3 a 5 días hábiles.
      </div>

      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Estimado cliente: en caso de no conocer la operación y/o desea reportar un pago repórtelo a la brevedad al
          correo cxc@${this.empresaId === '1' ? 'kabik.com.mx' : 'letech.mx'}
        </p>
      </div>
      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Lunes a Viernes 9:00am - 6:00pm y Sábado 9:00am - 1:00pm
        </p>
      </div>

      <div
        style="display:grid;grid-template-columns:auto auto auto; justify-content:center; gap: 15px; text-align: center; font-size: 14px">
        <a href="https://www.facebook.com/${this.empresaId == '1' ? 'kabikmx' : 'letechmx'}" style="text-decoration: none; color: #207fd3">
          Facebook
        </a>
        <a href="https://${this.empresaId == '1' ? 'kabik' : 'letech'}.mx/" style="text-decoration: none; color: #207fd3">
          ${this.empresaId == '1' ? 'Kabik' : 'Letech'}
        </a>
        <a href="mailto:ventas@${this.empresaId == '1' ? 'kabik.com' : 'letech'}.mx" style="text-decoration: none; color: #207fd3">
          Contactanos
        </a>
      </div>
    </div>
  </section>

</body>

</html>

    `;
    return htmlSend;
  }

  getMailCEDIS() {
    let dataPage: any = {};
    dataPage.today = new Date();
    dataPage.user = this.login.getDataClientePedido();
    dataPage.nombreVendedor = this.login.getNombreVendedor();
    dataPage.cartResumen = this.cartService.calcularResumen(null);

    let htmlSend: string = `
    <html>

<head>
</head>

<body>
  <section style="max-width: 1000px;margin: auto;" id="allMail">
    <div>
      `;

    if (this.getFromLocalStg('resumen-cart-login')?.totalKbCoins > 0) {
      htmlSend += `<p class="title-kabikCoin">
      <p style="text-align: center; font-weight: bold;">&#10024; Lo haz hecho muy bien!! haz utilizado
        <strong>${this.getFromLocalStg('resumen-cart-login')?.totalKbCoins}</strong> ${this.empresaId == '1' ? 'KabiCoins' : 'Puntos azules'} &#10024;
      </p>
      </>`;
    }

    htmlSend += `
    </div>


    <div style="display: block; max-width: 1350px; margin: auto;">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
        <div style="padding:20px 20px 5px 20px; display:inline-block; vertical-align:top; font-size: 3rem; font-weight: bold;">`;
          if (this.empresaId == '1') {
            htmlSend += `<span>KAB</span><span style="color: #39a5dd">IK</span>`;
          } else {
            htmlSend += `<span style="color: #29285b; font-style: italic">LE<span style="color: #179bd7">TECH</span></span>`;
          }
          htmlSend += `
        </div>

        <div style="display: inline-block;
        vertical-align: top;text-align: end;
        padding: 20px 20px 5px 20px;">
          <div style="display: grid; grid-template-columns: auto auto; gap: 15px; justify-content: flex-end;">
            <span>
              <p style="margin: 0;font-size: 18px;;">Pedido</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900; color: #00a61a;">
                [-REPLACE-PEDIDO-CEDIS-]
              </p>
            </span>
            <span>
              <p style="margin: 0;font-size: 18px;">Total</p>
              <p style="margin: 0;font-size: 1.3rem; font-weight: 900;">
                $[-REPLACE-PEDIDO-CEDIS-TOTAL-]
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 2px;
        width: 100%;
        background-color: #66a2d9;"></div>
    </div>


    <div style="max-width: 1350px;
    margin: auto;
    align-items: end;
    border-bottom: 1px solid #cacaca;">
      <div
        style="text-align: start; padding: 5px 20px 5px 20px;vertical-align:middle; width:50%;display: inline-block;">
        <div>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            ${dataPage.user.client_number} ${dataPage.user.company_name}
          </p>
          <p style=" margin: 0;
          font-size: 16px;
          margin-bottom: 5px;">
            Correo cliente:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.email
      }</strong>
          </p>

          <p style=" margin: 0;
            font-size: 16px;
            margin-bottom: 5px;">
            Teléfono:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.telefono ?? '-'
      }</strong>
          </p>
        </div>

        <p style="margin: 0;
        font-size: 16px;
        margin-bottom: 5px;">
          Vendedor: <span>${dataPage.user.vendedorNombre}</span>
        </p>

        <p style="margin: 0;
        font-size: 16px;">
          Generado por: <span>${dataPage.user.vendedorLevantaPedido ? dataPage.nombreVendedor : dataPage.user.nombre}</span>
        </p>

      </div>

      <div style="text-align: end;
      padding: 5px 20px 5px 20px;vertical-align:middle;width: calc(50% - 90px);
      display: inline-block;">
        <p style="font-size: 16px; margin: 0; margin-bottom: 5px;">
          ${this.datePipe.transform(dataPage.today, "dd/MM/yyyy HH:mm:ss")}
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Tipo de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("tipo-pago")}</span>
        </p>
        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("pasarela-pago")}</span>
        </p>
        <p style="font-size: 16px; margin: 0; margin-bottom: 5px;">
          ${this.getFromLocalStg('cliente-CFDI')} -
          ${this.getCFDIData(this.getFromLocalStg('cliente-CFDI'))?.description}
        </p>

        <p style="margin: 0; font-size: 16px; margin-bottom: 5px;">
          Método de entrega:
          <strong style="text-transform: uppercase; color: #06a81f;">
            ${this.getFromLocalStg("tipo-entrega-cedis") == 'sucursal' ? 'Recoger en sucursal' : 'Enviar por paquetería'}
          </strong>
        </p>

        `;


    htmlSend += `
      </div>`
    if (this.getFromLocalStg("address-envio-cedis") &&
      this.getFromLocalStg("tipo-entrega-cedis") == "envio") {
      htmlSend += `
      <div style="border: 1px solid #ddd;
        padding: 5px 10px;
        text-align: initial;
        border-radius: 8px;
        background-color: #f2f2f2;
        width: calc(100% - 70px);
        margin: 5px 20px">
        <p style="color:#06a81f; font-size:16px;margin: 0;
          margin-bottom: 0px;">
          Dirección de envío
        </p>
        <div style="display: grid; grid-template-columns: auto auto;">
          <p style="margin:0;font-size:14px;margin-bottom:2px;">
            <strong style="">Nombre:</strong> ${this.getFromLocalStg("address-envio-cedis").nombre}
          </p>
          <p style="margin:0;font-size:14px;margin-bottom:2px;">
            <strong style="">Dirección:</strong> 
            ${this.getFromLocalStg("address-envio-cedis").calle}
            ${this.getFromLocalStg("address-envio-cedis").numExterior}
            ${this.getFromLocalStg("address-envio-cedis").numInterior == '' ? '' : '-' + this.getFromLocalStg("address-envio-cedis").numInterior}, 
            Col. ${this.getFromLocalStg("address-envio-cedis").colonia}
          </p>
          <p style="margin:0;font-size:14px;margin-bottom:2px;">
            <strong style="">Referencia:</strong> ${this.getFromLocalStg("address-envio-cedis").referencia}
          </p>
          <p style="margin:0;font-size:14px;margin-bottom:2px;">
            <strong style="">Teléfono:</strong> ${this.getFromLocalStg("address-envio-cedis").telefono}
          </p>
        </div>
      </div>`;
    }




    htmlSend += `
    </div>
    </div>



    </div>


    <div style="max-width: 1350px;
      margin: auto;
      border-top: 1px solid #cacaca;
      border-bottom: 1px solid #cacaca;">



      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(12%);">Almacén</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(16%);">Clave</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(40%);">Descripción</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(8% - 10px);">Cantidad</p>
      <p style="text-align: center;
      margin: 3px 0;
      font-size: 14px;
      font-weight: 900;display:inline-block; width:calc(10%);">Precio</p>
      <p style="text-align: end;
      margin: 3px 0;
      font-size: 14px;
      padding-right: 0px;
      font-weight: 900;
      display: inline-block;
      width: calc(10% - 10px);">Importe</p>
    </div>


    `;

    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      if (itemProduct.isCedis) {
        htmlSend += `<div style="max-width: 1350px;
          margin: auto;
          border-top: 1px solid #cacaca;
          border-bottom: 1px solid #cacaca;">


      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(12%);color: #00a61a; text-transform: uppercase;">
        ${itemProduct.isCedis ? "CDMX" : this.empresaId == '1' ? "Tampico" : this.login.getDataClientePedido().sucursal}
      </p>

      <div style="text-align: center;
      margin: 5px 0;
      font-size: 14px;vertical-align: top;
      display:inline-block; width:calc(16%);">

        <p style="margin:0;"><span style="color: #00a61a">${itemProduct.ClaveArticuloProveedor}</span></p>

      </div>

      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(40%);">${itemProduct.Descripcion}</p>

      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(8% - 10px);">
        ${itemProduct.CANT_CAR}
      </p>


      <p style="text-align: center;
        margin: 5px 0;
        font-size: 14px;vertical-align: top;
        display:inline-block; width:calc(10%);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, 1,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, 1,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `
      <p style="text-align: end;
        margin: 5px 0;
        font-size: 14px;
        padding-right: 0px;
        vertical-align: top;
        display: inline-block;
        width: calc(10% - 10px);">`


        if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, itemProduct.CANT_CAR,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        } else {
          htmlSend += `<b>
          <b>
            ${this.currency.transform(this.precioPipe.transform(
            this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, itemProduct.CANT_CAR,
              (itemProduct.PagarConKabikCoin === undefined
                ? false
                : itemProduct.PagarConKabikCoin))), '$ ')}
          </b>
        </b>`;
        }


        htmlSend += `</p>`;

        htmlSend += `
    </div>`;
      }
    });

    htmlSend += `
    <div style="max-width: 1350px;
      margin: auto;
      border-top: 1px solid #cacaca;
      border-bottom: 1px solid #cacaca;">


      <p style="text-align: center;
        margin: 3px 0;
        font-size: 14px;
        font-weight: 900;display:inline-block; width:calc(20% - 10px);">Empresa</p>
      <p style="text-align: center;
        margin: 3px 0;
        font-size: 14px;
        font-weight: 900;display:inline-block; width:calc(20% - 10px);">Prioridad</p>
      <p style="text-align: center;
        margin: 3px 0;
        font-size: 14px;
        font-weight: 900;display:inline-block; width:calc(20% - 10px);">Existencias</p>
    </div>`;

    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      if (itemProduct.isCedis) {
        htmlSend += `<div style="max-width: 1350px;
          margin: auto;
          border-top: 1px solid #cacaca;
          border-bottom: 1px solid #cacaca;">

      <p
        style="text-align: center;
          margin: 5px 0;
          font-size: 14px;
          font-weight: 900;display:inline-block; width:calc(20% - 10px);color: #00a61a; text-transform: uppercase; font-weight: 900">
        ${itemProduct.Cedis[0].Proveedor}
      </p>
      <p
        style="text-align: center;
          margin: 5px 0;
          font-size: 14px;
          font-weight: 900;display:inline-block; width:calc(20% - 10px);color: #000; text-transform: uppercase; font-weight: 900">
        ${itemProduct.Cedis[0].Prioridad}
      </p>
      <p
        style="text-align: center;
          margin: 5px 0;
          font-size: 14px;
          font-weight: 900;display:inline-block; width:calc(20% - 10px);color: #000; text-transform: uppercase; font-weight: 900">
        ${itemProduct.Cedis[0].TotalExistencias}
      </p>
      <p style="width:calc(20% - 10px);"></p>
      <p style="width:calc(20% - 10px);"></p>
    </div>`}
    });

    htmlSend += `

    <div style="max-width: 1350px;
        margin: auto;
        align-items: end;">
      <div></div>

      <div style="text-align: end;
        padding: 10px 20px;">

        <p style="text-align: end;margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        padding-right: 4px;
        justify-content: end;
        text-align:end">
          Envio:
          <strong>$ ${this.precioPipe.transform(this.getFromLocalStg('resumen-cart-login')?.envio)}</strong>
        </p>

        <p style="text-align: end;margin: 0;
          font-size: 14px;
          margin-bottom: 5px;
          padding-right: 4px;
          justify-content: end;
          text-align:end">
          SubTotal:
          <strong>$ [-REPLACE-PEDIDO-CEDIS-SUBTOTAL-]</strong>
        </p>
        <p style="text-align: end;margin: 0;
          font-size: 14px;
          margin-bottom: 5px;
          padding-right: 4px;
          justify-content: end;
          text-align:end">
          IVA (16%):
          <strong>$ [-REPLACE-PEDIDO-CEDIS-IVA-]</strong>
        </p>

        <div style="text-align: end;margin: 0;
          font-size: 14px;
          margin-bottom: 5px;
          padding-right: 4px;
          justify-content: end;
          text-align:end">
          <div style="height: 2px;
          width: 100%;
          background-color: #66a2d9;"></div>
        </div>

        <p style="text-align: end;margin: 0;
          font-size: 16px;
          margin-bottom: 10px;
          padding-right: 4px;
          margin-bottom: 0px;
          justify-content: end;
          text-align:end">
          <strong>Total: $ [-REPLACE-PEDIDO-CEDIS-TOTAL-]</strong>
        </p>
      </div>
    </div>

    <div style="display:grid;max-width:700px;margin:auto;border: 1px solid #eaeaea;
      padding: 10px;
      border-radius: 8px;">

      ${this.generateBankAccountsTable(this.empresaId)}
    </div>

    <div style="display: grid;
    max-width: 1350px;
    margin: auto;
    align-items: end;
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #e7e6e6;
    border-radius: 8px;
    gap: 5px;">
      <div style="font-size: 14px">
        <strong>Importante: </strong>El tipo de cambio es ilustrativo, el monto en pesos totalizado no es
        definitivo. Se calculará el monto total utilizando el tipo de cambio
        comercial vigente en la fecha de emisión de la factura correspondiente.
      </div>
      <div style="font-size: 14px">
        <strong>Importante: </strong>Si este pedido no se factura dentro de 48 horas se cancelará de manera automática.
        El tiempo de entrega estimado para articulos del almacén CDMX son 3 a 5 días hábiles.
      </div>

      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Estimado cliente: en caso de no conocer la operación y/o desea reportar un pago repórtelo a la brevedad al
          correo cxc@${this.empresaId === '1' ? 'kabik.com.mx' : 'letech.mx'}
        </p>
      </div>
      <div style="font-size: 14px;">
        <p style="text-align:center; margin:0;">
          Lunes a Viernes 9:00am - 6:00pm y Sábado 9:00am - 1:00pm
        </p>
      </div>

      <div
        style="display:grid;grid-template-columns:auto auto auto; justify-content:center; gap: 15px; text-align: center; font-size: 14px">
        <a href="https://www.facebook.com/${this.empresaId == '1' ? 'kabikmx' : 'letechmx'}" style="text-decoration: none; color: #207fd3">
          Facebook
        </a>
        <a href="https://${this.empresaId == '1' ? 'kabik' : 'letech'}.mx/" style="text-decoration: none; color: #207fd3">
          ${this.empresaId == '1' ? 'Kabik' : 'Letech'}
        </a>
        <a href="mailto:ventas@${this.empresaId == '1' ? 'kabik.com' : 'letech'}.mx" style="text-decoration: none; color: #207fd3">
          Contactanos
        </a>
      </div>
    </div>
  </section>

</body>

</html>

    `;
    return htmlSend;

  }

  getMailComplete() {
    let dataPage: any = {};
    dataPage.today = new Date();
    dataPage.user = this.login.getDataClientePedido();
    dataPage.cartResumen = this.cartService.calcularResumen(null);

    console.log(dataPage);

    let htmlSend: string = `
  <html>
    <head>
      <style>

      </style>
    </head>

    <body>

        <section style="max-width: 1000px;
        margin: auto;" id="allMail">

        <div style="">
          <h2 style="font-size: 1.8rem;

          grid-template-columns: auto auto;
          justify-content: center;
          column-gap: 15px;
          margin-top: 20px;text-align:center">
          <img
          style="width: 30px;
          display: inline-block;
          vertical-align: middle;"
            src="https://api.kabik.mx/images/check.png"
          />
            <b style="display: inline-block;
            vertical-align: middle;">¡Tu pedido está confirmado!</b>
          </h2>
        </div>


        <div style="padding:20px;display:inline-block;vertical-align:top;width: 250px;">

          <img style="width:250px" src="https://api.kabik.mx/images/logo_original.png" data-bit="iit">

          <p>
          Soluciones tecnológicas a tu alcance
          </p>
        </div>

      <div style="display: inline-block;
      vertical-align: top;text-align: end;
      padding: 20px;width: calc(100% - 340px);">
        <p style="margin: 0;font-size: 18px;
        margin-bottom: 10px;">Pedido</p>
        <p style="margin: 0;font-size: 30px;
        font-weight: 900;
        color: #00a61a;">[[-REPLACE-PEDIDO-]]</p>
        <p style="margin: 10px 0;
        font-size: 18px;">
          ${this.getFromLocalStg('cliente-CFDI')} -
          ${this.getCFDIData(this.getFromLocalStg('cliente-CFDI'))?.description}
        </p>
        <p class="dte">${this.datePipe.transform(dataPage.today, "dd/MM/yyyy")}</p>
      </div>

      <div style="height: 2px;
      width: 100%;
      background-color: #66a2d9;"></div>
    </div>


    <div style="max-width: 1350px;
    margin: auto;
    align-items: end;
    border-bottom: 1px solid #cacaca;">
      <div style="text-align: start;
      padding: 20px;
      margin-bottom: 8px;vertical-align:middle; width:50%;display: inline-block;">
        <div>
          <p style=" margin: 0;
          font-size: 18px;
          margin-bottom: 10px;">
            ${dataPage.user.client_number} ${dataPage.user.company_name}
          </p>
          <p style=" margin: 0;
          font-size: 18px;
          margin-bottom: 10px;">
            Correo cliente:
            <strong style="color: #055fad; text-decoration: underline">${dataPage.user.email
      }</strong>
          </p>
        </div>

        <p style="margin: 0;
        font-size: 18px;
        margin-bottom: 10px;">
          Vendedor: <span>${dataPage.user.vendedorNombre}</span>
        </p>

        <p style="margin: 0;
        font-size: 18px;
        margin-bottom: 10px;">
          Pedido generado por: <span>${dataPage.user.nombre}</span>
        </p>

      </div>

      <div style="text-align: end;
      padding: 20px;vertical-align:middle;width: calc(50% - 90px);
      display: inline-block;">
        <p style="margin: 0;
        font-size: 18px;
        margin-bottom: 10px;">
          Tipo de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("pasarela-pago")}</span>
        </p>
        <p style="margin: 0;
        font-size: 18px;
        margin-bottom: 10px;margin-bottom: 40px;">
          Método de compra: <span style="text-transform: capitalize;">${this.getFromLocalStg("tipo-pago")}</span>
        </p>

        <p style="margin: 0;
        font-size: 18px;
        margin-bottom: 10px;">
          Método de entrega:
          <strong style="text-transform: uppercase;
          color: #06a81f;">${this.getFromLocalStg("tipo-entrega-sucursal") == "sucursal"
        ? "Recoger en sucursal"
        : (this.getFromLocalStg("tipo-entrega-sucursal") == "envio" ? "Enviar por paquetería" : "Enviar a domicilio")}</strong>
        </p>



        `;

    if (this.getFromLocalStg('address-envio-cedis') && this.getFromLocalStg('tipo-entrega-cedis') == 'envio') {
      htmlSend += `
          <div style="border: 1px solid #ddd;
        padding: 10px;
        text-align: initial;
        border-radius: 8px;
        background-color: #f2f2f2;">
                    <p style="color:#06a81f; font-size:20px;margin: 0;
          margin-bottom: 0px;
        margin-bottom: 10px;">
                    Dirección de envío
                    </p>

                    <p style="margin:0;font-size:18px;margin-bottom:10px">
                      <strong style="">Nombre:</strong> ${this.getFromLocalStg("address-envio").nombre} </p>
                      <p style="margin:0;font-size:18px;margin-bottom:10px">
                      <strong style="">Calle:</strong> ${this.getFromLocalStg("address-envio").calle} </p>
                      <p style="margin:0;font-size:18px;margin-bottom:10px">
                      <strong style="">Colonia:</strong> ${this.getFromLocalStg("address-envio").colonia} </p>
                      <p style="margin:0;font-size:18px;margin-bottom:10px">
                      <strong style="">Referencia:</strong> ${this.getFromLocalStg("address-envio").referencia} </p>
                      <p style="margin:0;font-size:18px;margin-bottom:10px">
                      <strong style="">Teléfono:</strong> ${this.getFromLocalStg("address-envio").telefono} </p>
                  </div>`;
    }




    htmlSend += `</div>



    </div>


    <div style="max-width: 1350px;
    margin: auto;
    border-top: 1px solid #cacaca;
    border-bottom: 1px solid #cacaca;">

      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 10px);">Almacén</p>
      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 10px);">Descripción</p>
      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 10px);">Cantidad</p>
      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 10px);">Precio</p>
      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 10px);">Importe</p>
    </div>


      `;

    this.getFromLocalStg('items-cart-login').forEach(itemProduct => {
      htmlSend += `<div style="max-width: 1350px;
        margin: auto;
        border-top: 1px solid #cacaca;
        border-bottom: 1px solid #cacaca;">

        <p
        style="text-align: center;
        margin: 10px 0;
        font-size: 20px;
        font-weight: 900;display:inline-block; width:calc(20% - 4px);color: #00a61a; text-transform: uppercase; font-weight: 900"
      >
        ${itemProduct.isCedis ? "CDMX" : "Tampico"}
      </p>

      <div style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      display:inline-block; width:calc(20% - 4px);">

          <p><strong style="color: #00a61a;font-weight: 900;">${itemProduct.ClaveArticuloProveedor}</strong></p>
          <p>${itemProduct.Descripcion}</p>
      </div>
      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 4px);">${itemProduct.CANT_CAR}</p>


      <p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 4px);">`


      if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
        htmlSend += `<b>
        <b>
      $ ${this.precioPipe.transform(this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, 1, (itemProduct.PagarConKabikCoin === undefined
          ? false
          : itemProduct.PagarConKabikCoin)))}
        </b>
        </b>`;
      } else {
        htmlSend += `<b>
        <b>
      $ ${this.precioPipe.transform(this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, 1, (itemProduct.PagarConKabikCoin === undefined
          ? false
          : itemProduct.PagarConKabikCoin)))}
        </b>
        </b>`;
      }


      htmlSend += `<p style="text-align: center;
      margin: 10px 0;
      font-size: 20px;
      font-weight: 900;display:inline-block; width:calc(20% - 4px);">`


      if (Number(itemProduct.PrecioNormal) > Number(itemProduct.PrecioVenta) && itemProduct.PrecioVenta !== null) {
        htmlSend += `<b>
        <b>
      $ ${this.precioPipe.transform(this.calcularPipe.transform(itemProduct.PrecioVenta, itemProduct.PrecioVenta, itemProduct.CANT_CAR, (itemProduct.PagarConKabikCoin === undefined
          ? false
          : itemProduct.PagarConKabikCoin)))}
        </b>
        </b>`;
      } else {
        htmlSend += `<b>
        <b>
      $ ${this.precioPipe.transform(this.calcularPipe.transform(itemProduct.PrecioNormal, itemProduct.PrecioVenta, itemProduct.CANT_CAR, (itemProduct.PagarConKabikCoin === undefined
          ? false
          : itemProduct.PagarConKabikCoin)))}
        </b>
        </b>`;
      }


      htmlSend += `</p>`;

      htmlSend += `</div>`;
    });

    htmlSend += `

      <div style="max-width: 1350px;
      margin: auto;
      align-items: end;
      border-bottom: 1px solid #cacaca;">
      <div></div>

      <div style="text-align: end;
      padding: 20px;">

      <p style="text-align: end;margin: 0;
        font-size: 18px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          Envio:
          <strong>$ ${this.getFromLocalStg('resumen-cart-login')?.envio}</strong>
        </p>

        <p style="text-align: end;margin: 0;
        font-size: 18px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          SubTotal:
          <strong>$ ${dataPage.cartResumen.subTotal}</strong>
        </p>
        <p style="text-align: end;margin: 0;
        font-size: 18px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          IVA (16%):
          <strong>$ ${dataPage.cartResumen.iva}</strong>
        </p>

        <div style="text-align: end;margin: 0;
        font-size: 18px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
        <div style="height: 2px;
        width: 100%;
        background-color: #66a2d9;"></div>
        </div>

        <p style="text-align: end;margin: 0;
        font-size: 18px;
        margin-bottom: 10px;
        padding-right: 20px;
        margin-bottom: 10px;
        justify-content: end;
        text-align:end">
          <strong
            >Total: $ ${dataPage.cartResumen.total}</strong
          >
        </p>
      </div>
    </div>

    <div style="display:grid;max-width:700px;margin:auto;margin-top:20px;border: 1px solid #eaeaea;
    padding: 10px;
    border-radius: 8px;">
            <p>
            Cuentas Bancarias
            </p>

            <table style="border: 1px solid #dddddd;
      text-align: center;
      border:none;
      padding: 8px;">
      <tr>
        <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">Banco</th>
        <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">Número de cuenta</th>
        <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">Moneda</th>

      <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">CLABE</th>

      </tr>
      <tr>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">Banorte</td>
        <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">0354164074</td>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">MXN</td>

      <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">072813003541640743</td>

      </tr>

      <tr>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">Banorte</td>
        <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">0356115913</td>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">USD</td>

      <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">072813003561159133</td>

      </tr>

      <tr>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">BBVA</td>
        <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">0111071467</td>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">MXN</td>

      <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">012813001110714677</td>

      </tr>

       <tr>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">BANAMEX</td>
        <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">70122811911</td>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">MXN</td>

      <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">002813701228119115</td>

      </tr>

      <tr>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">SANTANDER</td>
        <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">65509430018</td>
        <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;
      padding: 8px;">MXN</td>

      <td style="border: 1px solid #dddddd;border:none;text-align: center;
      padding: 8px;">014813655094300100</td>

      </tr>

            </table>
            </div>

    <div style="display: grid;
    max-width: 1350px;
    margin: auto;
    align-items: end;
    margin-top: 20px;">
      <div style="padding: 20px;
      background-color: #e7e6e6;
      border-radius: 8px;">
        <strong>Importante: </strong>El tipo de cambio es ilustrativo, el monto en pesos totalizado no es
        definitivo. Se calculará el monto total utilizando el tipo de cambio
        comercial vigente en la fecha de emisión de la factura correspondiente.
      </div>
    </div>

    <div style="display: grid;
    max-width: 1350px;
    margin: auto;
    align-items: end;
    margin-top: 20px;">
      <div style="padding: 20px;
      background-color: #e7e6e6;
      border-radius: 8px;">
        <strong>Importante: </strong>Si este pedido no se factura dentro de 48 horas se cancelará de manera automática.
        El tiempo de entrega estimado para articulos del almacén CDMX son 3 a 5 días hábiles.
      </div>
    </div>

    <div style="display:grid; grid-template-columns:40% 20% 40%; margin-top:20px; justify-content:center">
    <div></div>
    <div style="text-align:center">
      <a href="https://www.facebook.com/kabikmx/" style="text-decoration: none;
color: #333;">
        <img style="width:40px" src="https://cdn-icons-png.flaticon.com/512/5968/5968764.png "/>
      </a>
      <a href="https://kabik.mx/" style="text-decoration: none;
color: #333;">
        <img style="width:40px" src="https://cdn-icons-png.flaticon.com/512/3308/3308395.png"/>
      </a>
      <a href="mailto:ventas@kabik.com.mx" style="text-decoration: none;
color: #333;">
        <img style="width:40px" src="https://cdn-icons-png.flaticon.com/512/10400/10400964.png"/>
      </a>
    </div>
    <div></div>
    </div>

    <div style="margin-top:20px;padding:20px;background-color:#e7e6e6;border-radius:8px; color: #333;">

      <p style="text-align:start;margin:0;margin-bottom:12px;color: #333;">
      Estimado cliente: en caso de no conocer la operación y/o desea reportar un pago repórtelo a la brevedad al correo
      </p>

      <p style="text-align:center;margin:0;margin-bottom:12px;color: #333;">
       <a href="mailto:cxc@kabik.com.mx" style="text-decoration: none;
color: #333;">cxc@kabik.com.mx</a>
      </p>

      <p style="text-align:center;margin:0;margin-bottom:12px;color: #333;">
      Lunes a Viernes 9:00am - 6:00pm
      </p>

      <p style="text-align:center;margin:0;margin-bottom:12px;color: #333;">
      Sábado 9:00am - 1:00pm
      </p>

      <p style="text-align:center;margin:0;margin-bottom:12px;color: #333;">
      Francisco Villa #209 Col. Nuevo Progreso
      </p>

      <p style="text-align:center;margin:0;margin-bottom:12px;color: #333;">
     C.P. 89318, Tampico, Tamps.
      </p>
    </div>
      </section>

    </body>
  </html>
  `;
    return htmlSend;
  }

  public getFromLocalStg(key: string) {
    return this.utilService.isJson(localStorage.getItem(key))
      ? JSON.parse(localStorage.getItem(key))
      : localStorage.getItem(key);
  }

  getCFDIData(key) {
    return this.utilService.getCFDIData(key);
  }

  private getBankAccounts(business: string): BankAccount[] {
    const bankAccounts: { [key: string]: BankAccount[] } = {
      1: [
        {
          bank: 'BANORTE',
          accountNumber: '0354164074',
          currency: 'MXN',
          clabe: '072813003541640743'
        },
        {
          bank: 'BANORTE',
          accountNumber: '0356115913',
          currency: 'USD',
          clabe: '072813003561159133'
        },
        {
          bank: 'BBVA',
          accountNumber: '0111071467',
          currency: 'MXN',
          clabe: '012813001110714677'
        },
        {
          bank: 'BANAMEX',
          accountNumber: '70122811911',
          currency: 'MXN',
          clabe: '002813701228119115'
        },
        {
          bank: 'SANTANDER',
          accountNumber: '65509430018',
          currency: 'MXN',
          clabe: '014813655094300100'
        }
      ],
      2: [
        {
          bank: 'BANORTE',
          accountNumber: '0283235533',
          currency: 'MXN',
          clabe: '072813002832355337'
        },
        {
          bank: 'BANORTE',
          accountNumber: '0292157954',
          currency: 'USD',
          clabe: '072813002921579545'
        },
        {
          bank: 'BBVA',
          accountNumber: '0110930229',
          currency: 'MXN',
          clabe: '012813001109302294'
        },
        {
          bank: 'BBVA',
          accountNumber: '0111086723',
          currency: 'USD',
          clabe: '012813001110867236'
        },
        {
          bank: 'BANAMEX',
          accountNumber: '70121568711',
          currency: 'MXN',
          clabe: '002813701215687113'
        }
      ]
    };

    return bankAccounts[business] || [];
  }

  public generateBankAccountsTable(business: string): string {
    const accounts = this.getBankAccounts(business);

    if (accounts.length === 0) return '';

    return `
        <table style="border: 1px solid #dddddd;
          text-align: center;
          border:none;
          padding: 5px;
          font-size: 14px;">
        <tr>
          <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">Banco</th>
          <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">Número de cuenta</th>
          <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">Moneda</th>
          <th style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">CLABE</th>
        </tr>
        ${accounts.map(account => `
        <tr>
          <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">${account.bank}</td>
          <td style="border: 1px solid #dddddd;border:none;text-align: center;padding: 2px;">${account.accountNumber}</td>
          <td style="border: 1px solid #dddddd;border:none;font-weight:900;text-align: center;padding: 2px;">${account.currency}</td>
          <td style="border: 1px solid #dddddd;border:none;text-align: center;padding: 2px;">${account.clabe}</td>
        </tr>
        `).join('')}
      </table>
    `;
  }
}
